export default "__VITE_ASSET__CGsr6isA__"